import { Business, Person } from "@mui/icons-material";
import { roleColors, jobColors } from "../../../../../../../ui/colors";

export const categoryUIConfig = {
  Commercial: {
    icon: <Business sx={{ fontSize: 40 }} />,
    color: jobColors.visitQuote.color,
    subtitle: "OPTIMIZE BUSINESS OPERATIONS",
    description: "Manage cleaning services for offices, buildings, or large facilities efficiently.",
  },
  Residential: {
    icon: <Person sx={{ fontSize: 40 }} />,
    color: jobColors.visitQuote.color,
    subtitle: "PERFECT FOR HOME SERVICES",
    description: "Offer or request cleaning services for homes and apartments with full flexibility.",
  },
} as const;
